import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  // const team = [
  //   {
  //     id: 1,
  //     name: 'John Williams',
  //     role: 'Founder & Master Technician',
  //     icon: '👨‍🔧',
  //   },
  //   {
  //     id: 2,
  //     name: 'Sarah Thompson',
  //     role: 'Head of Operations',
  //     icon: '👩‍💼',
  //   },
  //   {
  //     id: 3,
  //     name: 'Mike Johnson',
  //     role: 'Senior Technician',
  //     icon: '👨‍🔧',
  //   },
  //   {
  //     id: 4,
  //     name: 'Emma Davis',
  //     role: 'Customer Service Manager',
  //     icon: '👩‍💼',
  //   },
  // ];

  const achievements = [
    { icon: '🏆', title: 'Industry Leading', description: '15+ years in automotive body repair' },
    { icon: '🔧', title: 'Expert Team', description: 'Certified technicians with proven expertise' },
    { icon: '😊', title: 'Customer First', description: '98% customer satisfaction rate' },
    { icon: '💰', title: 'Best Value', description: 'Competitive pricing without compromising quality' },
  ];

  return (
    <main className="about-page">
      {/* Header */}
      <section className="about-header">
        <div className="container">
          <h1>About West Drayton Body Works</h1>
          <p>Your trusted partner for professional automotive repair services</p>
        </div>
      </section>

      {/* Company Story */}
      <section className="company-story container p-40">
        <div className="story-grid">
          <div className="story-content">
            <h2>Our Story</h2>
            <p>
              West Drayton Body Works was founded with a simple mission: to provide the highest
              quality car body repair services in West Drayton and the surrounding areas.
            </p>
            <p>
              With over 15 years of experience in the automotive industry, our team has built a
              reputation for excellence, reliability, and customer satisfaction. We started as a
              small operation and have grown into one of the most trusted repair shops in the
              region.
            </p>
            <p>
              Our commitment to quality craftsmanship and customer service has remained
              unwavering throughout our journey. We invest in the latest equipment and training
              to ensure that every vehicle we work on receives the best possible care.
            </p>
            <p>
              Today, we're proud to serve hundreds of satisfied customers and continue to expand
              our services to meet the evolving needs of our community.
            </p>
          </div>
          <div className="story-image">
            <div className="placeholder-large">🏢</div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="values-section p-40">
        <div className="container">
          <h2 className="text-center">Our Core Values</h2>
          <div className="grid grid-3">
            <div className="value-card">
              <span className="value-icon">🎯</span>
              <h3>Quality</h3>
              <p>
                We never compromise on quality. Every repair is done right the first time with
                attention to detail.
              </p>
            </div>
            <div className="value-card">
              <span className="value-icon">🤝</span>
              <h3>Integrity</h3>
              <p>
                We're honest and transparent in our dealings with customers. No hidden costs or
                surprises.
              </p>
            </div>
            <div className="value-card">
              <span className="value-icon">⚡</span>
              <h3>Efficiency</h3>
              <p>
                We work quickly without cutting corners. Fast turnaround times with professional
                results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="achievements-section container p-40">
        <h2 className="text-center">Why Choose Us?</h2>
        <div className="grid grid-2">
          {achievements.map((achievement, idx) => (
            <div key={idx} className="achievement-card">
              <span className="achievement-icon">{achievement.icon}</span>
              <h3>{achievement.title}</h3>
              <p>{achievement.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Team */}
      {/* <section className="team-section p-40">
        <div className="container">
          <h2 className="text-center">Meet Our Team</h2>
          <p className="text-center section-intro">
            Expert technicians dedicated to providing the best service
          </p>
          <div className="grid grid-4">
            {team.map((member) => (
              <div key={member.id} className="team-member">
                <div className="member-avatar">{member.icon}</div>
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Stats */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Vehicles Repaired</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">15+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Customer Satisfaction</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">Expert Technicians</div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="certifications-section container p-40">
        <h2 className="text-center">Certifications & Standards</h2>
        <div className="grid grid-3">
          <div className="cert-card">
            <span className="cert-icon">✓</span>
            <h3>Insurance Approved</h3>
            <p>Approved by major insurance providers for direct billing services</p>
          </div>
          <div className="cert-card">
            <span className="cert-icon">✓</span>
            <h3>Manufacturer Certified</h3>
            <p>Certified by leading automotive manufacturers</p>
          </div>
          <div className="cert-card">
            <span className="cert-icon">✓</span>
            <h3>Health & Safety</h3>
            <p>Full compliance with UK health and safety regulations</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container">
          <h2>Experience Our Service Difference</h2>
          <p>Contact us today for a free quote or to discuss your automotive needs</p>
          <Link to="/quote" className="btn btn-primary btn-large">
            Get a Free Quote
          </Link>
        </div>
      </section>
    </main>
  );
};

export default About;
